module.exports = __webpack_public_path__ + "img/KM118MEG.be8c3dfe.png";